import { Link } from "react-router-dom";
import type { Comic } from "@/types/comic";
import { formatCount } from "@/utils/comic";

interface ComicCardProps {
  comic: Comic;
}

export default function ComicCard({ comic }: ComicCardProps) {
  return (
    <Link
      to={`/detail/${comic.id}`}
      className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-primary-300"
    >
      <div className="relative w-full aspect-[3/4] overflow-hidden bg-background-200">
        <img
          src={comic.cover}
          alt={`${comic.title} 韩漫双女主题材封面`}
          title={`${comic.title} 双女主韩漫在线观看`}
          className="h-full w-full object-cover object-top transition-transform duration-300 group-hover:scale-105"
        />
        <span
          className={`absolute left-2 top-2 rounded-md px-2 py-0.5 text-xs font-medium ${
            comic.status === "连载中"
              ? "bg-accent-500 text-background-50"
              : "bg-secondary-500 text-background-50"
          }`}
        >
          {comic.status}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-black/55 px-2 py-0.5 text-xs font-medium text-white">
          <i className="ri-star-fill text-accent-400" />
          {comic.rating}
        </span>
      </div>

      <div className="flex flex-1 flex-col p-3">
        <h3 className="truncate text-sm font-semibold text-foreground-950 group-hover:text-primary-700">
          {comic.title}
        </h3>
        <p className="mt-1 line-clamp-1 text-xs text-foreground-500">{comic.author}</p>

        <div className="mt-2 flex flex-wrap gap-1">
          {comic.genres.slice(0, 2).map((genre) => (
            <span
              key={genre}
              className="rounded-full bg-secondary-100 px-2 py-0.5 text-[11px] font-medium text-secondary-900"
            >
              {genre}
            </span>
          ))}
        </div>

        <div className="mt-auto pt-3">
          <p className="truncate text-xs text-foreground-600">{comic.latestChapter}</p>
          <div className="mt-1 flex items-center justify-between text-[11px] text-foreground-400">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" />
              {formatCount(comic.views)}
            </span>
            <span>{comic.updatedAt}</span>
          </div>
        </div>
      </div>
    </Link>
  );
}